import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { MessageService } from 'src/app/services/message.service';
import { ChooseCompensateAdobeModalComponent } from '../choose-compensate-adobe-modal/choose-compensate-adobe-modal.component';

@Component({
  selector: 'app-refund-wallet-adobe-modal',
  templateUrl: './refund-wallet-adobe-modal.component.html',
  styleUrls: ['./refund-wallet-adobe-modal.component.scss'],
})
export class RefundWalletAdobeModalComponent implements OnInit {
  loading = false;

  constructor(
    private dialogRef: DialogRef<RefundWalletAdobeModalComponent>,
    private api: BusApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private message: MessageService,
    private router: Router,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {}

  async refund() {
    try {
      this.loading = true;
      const r = await this.api.refundWalletAdobe(this.data.id);
      if (r.status === 0) {
        this.message.open('退款成功');
        this.dialogRef.close();
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      } else if (r.status === 12010) {
        this.message.warn('兑换钱包失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  back() {
    this.dialogRef.close();
    this.dialog.open(ChooseCompensateAdobeModalComponent, {
      width: '590px',
      data: this.data,
      panelClass: 'overflow-dialog',
    });
  }
}
